export class RuntimeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "RuntimeError";
  }
}

/**
 * Generate an unhandledrejection
 * Allows whichever error monitoring system
 * to capture the error without crashing the app
 * @param ErrClass
 */
export function softFail<TArgs extends any[]>(
  ErrClass: new (...args: TArgs) => Error,
  ...args: TArgs
): void {
  Promise.reject(new ErrClass(...args));
}
